import { render, staticRenderFns } from "./mediatorAccidentListCom.vue?vue&type=template&id=16823b0d"
import script from "./mediatorAccidentListCom.vue?vue&type=script&lang=js"
export * from "./mediatorAccidentListCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports